<template>
  <v-badge
    v-if="badgeContent"
    :content="badgeContent"
    :inline="inline"
    class="z-100"
    color="orange-darken-2"
    data-testid="notification-badge"
  >
    <slot />
  </v-badge>

  <template v-else>
    <slot />
  </template>
</template>

<script setup>
const props = defineProps({
  inline: {
    type: Boolean,
    default: false,
  },
  notificationCount: {
    type: Number,
    default: 0,
  },
});

const badgeContent = computed(() => {
  if (props.notificationCount < 1) return null;
  if (props.notificationCount > 9) return '9+';

  return props.notificationCount;
});
</script>
